import reduce from 'lodash/reduce';
import isEqual from 'lodash/isEqual';

function getDifferent(obj1: any, obj2: any) {
  return reduce(obj1, (result, value, key) => (isEqual(value, obj2[key])
    ? result : result.concat(key)), [] as string[]);
}

export default getDifferent;
